import { LinkDetails } from './types';
import { getVkAppUrl, getVkLink } from './builder';

/**
 * Получаем ссылку пригодную для перехода. Может использоваться, например в href
 */
export function parseUrlToAction(url: string, wrapVkAwayUrl: (url: string) => string): LinkDetails | null {
  const [protocol, path] = url.split('://', 2);

  if (!protocol || !path) {
    return null;
  }

  switch (protocol) {
    case 'http':
    case 'https':
    case 'vk':
      return { type: 'link', payload: wrapVkAwayUrl(url) };
    case 'fragment':
    case 'copy':
      return { type: protocol, payload: path };
    default:
      return null;
  }
}

const URL_MAX_DISPLAY_LENGHT = 55;

/**
 * Ограничивает ссылку по длине
 */
export function getUrlDisplayPart(url: string) {
  return url.length <= URL_MAX_DISPLAY_LENGHT ? url : `${url.substring(0, URL_MAX_DISPLAY_LENGHT - 2)}..`;
}

/**
 * Формируем ссылку для отображения ссылки, без технических деталей
 */
export function parseDisplayUrl(url: string, appId: number, vkMainUrl: string) {
  const [protocol, path] = url.split('://', 2);

  if (!protocol || !path) {
    return;
  }

  switch (protocol) {
    case 'vk':
      return getVkLink(vkMainUrl, path);
    case 'fragment':
      return getVkAppUrl(appId, vkMainUrl, path);
    default:
      return url;
  }
}
